import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';

export default function Login() {
  const [form, setForm] = useState({ username:'', password:'' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      const res = await api.post('/auth/login', form);
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('username', res.data.username);
      localStorage.setItem('role', res.data.role);
      localStorage.setItem('roleDisplay', res.data.roleDisplay || '');
      localStorage.setItem('roleColor', res.data.roleColor || '#3b82f6');
      localStorage.setItem('permissions', JSON.stringify(res.data.permissions || {}));
      navigate('/');
    } catch(err) {
      setError(err.response?.data?.error || 'Giriş başarısız');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div style={{
      minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'var(--dark)', position:'relative', overflow:'hidden',
    }}>
      <div style={{
        position:'absolute', width:600, height:600,
        background:'radial-gradient(circle, rgba(68,102,204,0.15) 0%, transparent 70%)',
        top:'50%', left:'50%', transform:'translate(-50%, -50%)', pointerEvents:'none',
      }} />

      <div style={{ width:'100%', maxWidth:400, padding:'0 24px', position:'relative' }}>
        <div style={{ textAlign:'center', marginBottom:40 }}>
          <div style={{
            width:64, height:64,
            background:'linear-gradient(135deg, var(--c3), var(--c5))',
            borderRadius:18, display:'flex', alignItems:'center', justifyContent:'center',
            fontSize:32, margin:'0 auto 16px', boxShadow:'0 8px 32px rgba(68,102,204,0.4)',
          }}>🤖</div>
          <h1 style={{ fontFamily:'Plus Jakarta Sans', fontSize:28, fontWeight:700, color:'var(--text)', marginBottom:8 }}>
            HR Bot Panel
          </h1>
          <p style={{ color:'var(--text3)', fontSize:14 }}>Yönetici girişi</p>
        </div>

        <div className="card" style={{ padding:32 }}>
          {error && <div className="alert alert-error">{error}</div>}
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label>Kullanıcı Adı</label>
              <input className="input" placeholder="Kullanıcı adı"
                value={form.username} onChange={e => setForm({ ...form, username:e.target.value })} required />
            </div>
            <div className="input-group" style={{ marginBottom:24 }}>
              <label>Şifre</label>
              <input className="input" type="password" placeholder="••••••••"
                value={form.password} onChange={e => setForm({ ...form, password:e.target.value })} required />
            </div>
            <button type="submit" className="btn btn-primary" disabled={loading}
              style={{ width:'100%', justifyContent:'center', padding:'13px' }}>
              {loading ? 'Giriş yapılıyor...' : 'Giriş Yap →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
